import React, { ReactElement } from 'react';
import { PebbleWarning } from '@ds/icons';
import { ContainerLayout } from 'layouts';
import { TranslationContext } from '@ds/react-utils';
import { HeaderIconContainer } from 'components/shared';

const PageNotFoundPage = (): ReactElement => {
    const translate = React.useContext(TranslationContext);

    return (
        <ContainerLayout>
            <ContainerLayout.Header>
                <HeaderIconContainer data-qa="verify-page-not-found-error-picto">
                    <PebbleWarning width="48px" height="48px" viewBox="1 1 22 22" />
                </HeaderIconContainer>
                <ContainerLayout.Header.Title titleDataQa="verify-page-not-found-title" title={translate("That page doesn't exist")} />
            </ContainerLayout.Header>
        </ContainerLayout>
    );
};

export default PageNotFoundPage;
